import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Custom
import { Permissions as P } from "@/lib/permissions";

// Types
import { IUserStatePreParsed } from "@/@types/common";

// Hook
function useNavigateByPermissions() {
  const navigate = useNavigate();
  return (permissionIds: number[]) => {
    if (permissionIds.indexOf(P.Operations.code) !== -1) {
      navigate('/operations');
    } else if (permissionIds.indexOf(P.Administration.code) !== -1) {
      navigate('/admin');
    } else {
      navigate("/");
    }
  }
}

export default useNavigateByPermissions;
